import { ITableColumn } from '@components/common/UTable/UTable';

import { RoleType, RoleTypeLabel } from '@/shared/roles/enums';

export const columns: ITableColumn[] = [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Название',
    dataIndex: 'description',
  },
  {
    title: 'Описание',
    dataIndex: 'detailedDescription',
    width: 300,
  },
  {
    title: 'Тип роли',
    dataIndex: 'type',
    render: (value: RoleType) => RoleTypeLabel[value],
  },
];
